// Initialize shared services with web storage adapter
import './services/initShared';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { setupGlobalErrorHandlers } from './services/errorReportingService';

// Setup global error handlers for uncaught errors (production only)
setupGlobalErrorHandlers();

// PWA: Force refresh when new version is available
if ('serviceWorker' in navigator) {
    // Check for updates on page load/focus
    const checkForUpdates = async () => {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration) {
            registration.update();
        }
    };

    // Check on visibility change (when app comes back to foreground)
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkForUpdates();
        }
    });

    // Listen for new service worker and reload when ready
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
    });

    // Initial check
    checkForUpdates();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);